import { atom } from "jotai";

export const settingsAtom = atom<any>({});
